module.exports = __webpack_public_path__ + "./awon_698f6dc1a96c055ea6315b03f4db3970.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2015/awon.png
// module id = 419
// module chunks = 0